<div class="time-picker-message">
    <div class="time-picker-header">
      <div class="time-picker-header-image-container" *ngIf="timePicker?.image?.url">
        <img class="time-picker-header-image" [attr.src]="timePicker?.image?.url">
      </div>
      <span class="time-picker-header-title">{{ timePicker.title }}</span>
    </div>
    <div class="time-picker-slots">
      <div *ngFor="let item of timePicker.timePicker.timeslots">
        <div class="time-picker-slot chat-message-{{ direction }}-item">
            <div class="time-picker-slot-title">{{ getTimeSlotTitle(item.startTime) | translate }}</div>
            <div class="time-picker-slot-date">{{ formatDate(item.startTime) }}</div>
            <div class="time-picker-slot-time">{{ formatTime(item.startTime) }}</div>
          </div>
      </div>
    </div>
  </div>
